<template>
  <div
    :title="display"
    class="address"
  >
    <a
      v-if="showGoogleMapLink"
      id="googleMapLink"
      :href="`https://www.google.com/maps/search/?api=1&query=${display}`"
      target="_blank"
    >
      <i :class="icon_class" />
    </a>
    <div
      class="address-display"
      v-html="display"
    />
  </div>
</template>

<script>

import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin],
  computed: {
    showGoogleMapLink() {
      return this.display.trim() !== '' && this.params.colDef.googleLink
    },
    icon_class: function() {
      if (this.params.colDef.icon_class === 'undefined') {
        return 'fa-solid fa-map-marked'
      }
      else {
        return this.params.colDef.icon_class
      }
    },
    googleLink() {
      return this.display.replace('</br>', ', ')
    }
  }
}
</script>

<style scoped>

#googleMapLink {
  margin-right: 10px;
  position: absolute;
  left: 0;
  top: 5px;
  display: flex;

}
.address-display{
  padding-left: 20px;
  line-height: 25px;
}

.address{
  position: relative;
}

</style>
